var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo, forwardRef } from 'react';
import { Link } from 'react-router-dom';
function SolidColor(color) {
    switch (color) {
        case "primary":
        default:
            return "text-white bg-primary-600 border-primary-600 shadow-sm hover:bg-primary-700  hover:border-primary-700 focus-visible:outline-primary-100 disabled:bg-primary-200 disabled:border-primary-200";
        case "gray":
            return "text-gray-700 bg-white border-gray-300 shadow-sm hover:bg-gray-50  focus-visible:outline-primary-100 disabled:text-gray-200 disabled:border-gray-200";
        case "error":
            return "text-white bg-error-600 border-error-600 shadow-sm hover:bg-error-700  hover:border-error-700 focus-visible:outline-error-100 disabled:bg-error-200 disabled:border-error-200";
    }
}
function OutlineColor(color) {
    switch (color) {
        default:
            return "";
        case "primary":
            return "text-primary-700 bg-white border-primary-300 shadow-sm hover:bg-primary-50 focus-visible:outline-primary-100 disabled:text-primary-200 disabled:border-primary-200";
        case "gray":
            return "text-gray-700 bg-white border-gray-300 shadow-sm hover:bg-gray-50 focus-visible:outline-primary-100 disabled:text-gray-200 disabled:border-gray-200";
        case "error":
            return "text-error-700 bg-white border-error-300 shadow-sm hover:bg-error-50 focus-visible:outline-error-100 disabled:text-error-300 disabled:border-error-200";
    }
}
function LinkColor(color) {
    switch (color) {
        default:
            return "";
        case "primary":
            return "text-primary-700 bg-transparent border-transparent text-primary-800 focus-visible:outline-primary-100 disabled:text-gray-300";
        case "gray":
            return "text-gray-700 bg-transparent border-transparent hover:text-gray-600 focus-visible:outline-primary-100 disabled:text-gray-300";
        case "error":
            return "text-error-700 bg-transparent border-transparent text-error-800 focus-visible:outline-error-100 disabled:text-error-300";
    }
}
export var Button = forwardRef(function ButtonComponent(_a, ref) {
    var _b = _a.size, size = _b === void 0 ? "md" : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, _d = _a.variant, variant = _d === void 0 ? "solid" : _d, disabled = _a.disabled, href = _a.href, to = _a.to, children = _a.children, _e = _a.className, propClassName = _e === void 0 ? "" : _e, rest = __rest(_a, ["size", "color", "variant", "disabled", "href", "to", "children", "className"]);
    var sizeClass = useMemo(function () {
        switch (size) {
            case "sm":
                return "text-sm px-3.5 py-2";
            case "md":
            default:
                return "text-sm px-4 py-2.5";
            case "lg":
                return "text-base px-4 py-2.5";
            case "xl":
                return "text-base px-5 py-3";
            case "2xl":
                return "text-lg px-7 py-4";
        }
    }, [size]);
    var colorClass = useMemo(function () {
        switch (variant) {
            default:
            case "solid":
                return SolidColor(color);
            case "outline":
                return OutlineColor(color);
            case "link":
                return LinkColor(color);
        }
    }, [color, variant]);
    var className = "border rounded disabled:pointer-events-none ".concat(colorClass, " ").concat(sizeClass, " font-semibold focus-visible:outline focus-visible:outline-4 transition-colors ").concat(propClassName);
    if (href) {
        return React.createElement("a", __assign({ ref: ref, href: href, className: className }, rest), children);
    }
    if (to) {
        return React.createElement(Link, __assign({ ref: ref, to: to, className: className }, rest), children);
    }
    return (React.createElement("button", __assign({ ref: ref, className: className, disabled: disabled }, rest, { type: rest.type || "button" }), children));
});
